// Events
import { COUNTDOWN_FINISHED } from 'events';
import { component } from 'picoapp';

import choozy from 'utils/choozy';

function attachBfcmVideoMute(root) {
  const button = root.querySelector('[data-bfcm-video-mute]');
  if (!button) return;

  const videos = [...root.querySelectorAll('[data-bfcm-bg-videos] video')];
  const audio = root.querySelector('[data-bfcm-bg-audio]');

  if (!videos.length && !audio) {
    button.hidden = true;
    return;
  }

  const mutedIcon = button.querySelector('[data-icon-muted]');
  const unmutedIcon = button.querySelector('[data-icon-unmuted]');
  const { labelMute, labelUnmute } = button.dataset;
  let soundOn = false;
  const useReplacementAudio = Boolean(audio);

  const isVisible = (element) =>
    element.checkVisibility?.() ?? element.offsetParent !== null;

  const apply = () => {
    videos.forEach((video) => {
      const visible = isVisible(video);
      video.muted = useReplacementAudio || !soundOn || !visible;
      if (soundOn && visible) video.play().catch(() => undefined);
    });

    if (audio) {
      if (soundOn) audio.play().catch(() => undefined);
      else audio.pause();
    }

    button.setAttribute('aria-label', soundOn ? labelMute : labelUnmute);
    if (mutedIcon) mutedIcon.hidden = soundOn;
    if (unmutedIcon) unmutedIcon.hidden = !soundOn;
  };

  button.addEventListener('click', () => {
    soundOn = !soundOn;
    apply();
  });

  window.addEventListener('resize', apply);
  document.addEventListener('visibilitychange', () => {
    if (!audio || !soundOn) return;
    if (document.hidden) audio.pause();
    else audio.play().catch(() => undefined);
  });
}

export default component(async (node, ctx) => {
  const { endDate } = choozy(node);
  const sitePassword = node.id;
  let sitePasswordDecoded = '';
  try {
    sitePasswordDecoded = atob(sitePassword);
  } catch {
    sitePasswordDecoded = '';
  }

  node.removeAttribute('id');
  attachBfcmVideoMute(node);

  if (endDate) {
    ctx.on(COUNTDOWN_FINISHED(endDate.dataset.endDate), () => {
      window.location.reload();
    });
  }

  const successVideoWrapper = node.querySelector('[data-success-video]');
  const passwordInput = node.querySelector('input[name="password"]');

  if (successVideoWrapper && passwordInput) {
    const passwordForm = passwordInput.closest('form');
    const successVideo = successVideoWrapper.querySelector('video');
    const successVideoLarge = successVideoWrapper.querySelector('video:last-child');

    const onSuccessVideoEnded = () => {
      passwordForm.submit();
    };

    successVideo.addEventListener('ended', onSuccessVideoEnded);
    successVideoLarge.addEventListener('ended', onSuccessVideoEnded);

    passwordForm.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(passwordForm);
      const password = formData.get('password');

      if (password) {
        const typedPassword = String(password);
        if (
          sitePasswordDecoded &&
          typedPassword.toLowerCase() === sitePasswordDecoded.toLowerCase()
        ) {
          successVideoWrapper.removeAttribute('hidden');

          if (window.matchMedia('(min-width: 1024px)').matches) {
            successVideoLarge.play().catch(onSuccessVideoEnded);
          } else {
            successVideo.play().catch(onSuccessVideoEnded);
          }
        } else {
          passwordForm.submit();
        }
      }
    });
  }
});
